import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getClinicInfoAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "clinic_code": "0000000002",
        "clinic_name": "Dent&Co牙醫診所1",
        "county": "臺北市",
        "area": "信義區",
        "address": "基隆路一段178號7樓",
        "tel": "(02)89115812",
        "goal": "123456",
        "profile": "https://cdn.dentco.tw/clicic/zm6pVwcUxYXfIawY.jpg",
        "fb_page": "https://www.facebook.com/companyfordentist/2",
        "website": "https://www.facebook.com/companyfordentist/123",
        "link1": "https://search.google.com/local/writereview?openExternalBrowser=1&placeid=https://search.google.com/local/writereview?placeid=ChIJPc3dPCmnQjQRAtuQ02cnDho&openExternalBrowser=1",
        "case_photo": [
          {
            "id": "144",
            "addr": "https://cdn.dentco.tw/case_photo/SJYfK9eA7YTxsYJL.jpg"
          },
          {
            "id": "145",
            "addr": "https://cdn.dentco.tw/case_photo/5k1h8bX9illzogNO.jpg"
          }
        ],
        "doctor": [
          {
            "doctor_code": "IwgUWU8zALU0",
            "doctor_name": "測試診所一號",
            "sort": "0",
            "job_title": ""
          },
          {
            "doctor_code": "heYCsLUF2PBH",
            "doctor_name": "測試診所二號",
            "sort": "1",
            "job_title": ""
          }
        ],
        "banner": [
          {
            "id": "80",
            "banner": "https://cdn.dentco.tw/clinic/banner/qbgQbrk4QsbPhy6r.jpg"
          }
        ],
        "clinic_opening": {
          "morning": ["10:00", "12:00"],
          "afternoon": ["14:00", "17:00"],
          "evening": ["18:00", "21:00"]
        },
        "clinic_open_date": [
          {"up": true, "middle": false, "down": true},
          {"up": false, "middle": false, "down": false},
          {"up": false, "middle": true, "down": false},
          {"up": true, "middle": false, "down": true},
          {"up": false, "middle": true, "down": false},
          {"up": false, "middle": false, "down": false},
          {"up": false, "middle": true, "down": false}
        ]
      }
    })
  }
  const url = apiUrl('clinic')
  return axios.get(url, {params})
}

export function updateClinicInfoAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic')
  return axios.post(url, data)
}

export function uploadClinicBannerAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'banner')
  return axios.post(url, data)
}

export function deleteClinicBannerAPI(id, params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'banner', id)
  return axios.delete(url, {params})
}

export function deleteClinicBannerBatchAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'del_banner')
  return axios.delete(url, {params})
}

export function uploadClinicCaseAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'case_photo')
  return axios.post(url, data)
}

export function deleteClinicCaseAPI(id, params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'case_photo', id)
  return axios.delete(url, {params})
}

export function getQuestionsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "10",
          "page_total": "2",
          "total": "18"
        },
        "data": [
          {
            "id": 1,
            "name": "江江江江",
            "phone": "0911111111",
            "time": "2021-12-30 (四) 15:56:04",
            "content": "三小？",
            "answer": null
          },
          {
            "id": 2,
            "name": "奧克",
            "phone": "0922222222",
            "time": "2021-12-28 (二) 09:10:00",
            "content": "啦！乾！",
            "answer": "文明人生"
          }
        ]
      }
    })
  }
  const url = apiUrl('question')
  return axios.get(url, {params})
}

export function replyQuestionsAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('question', 'reply')
  return axios.post(url, data)
}

export function getMenuServiceItemAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": "1",
          "img_url": "https://i.imgur.com/jzJskVm.png",
          "category": "預設項目",
          "title": "植牙療程",
          "intro": "植牙是把身體能接受的鈦金屬牙根植入骨頭，作為支撐假牙的根基"
        },
        {
          "id": "2",
          "img_url": "https://i.imgur.com/jzJskVm.png",
          "category": "預設項目",
          "title": "植牙療程",
          "intro": "植牙是把身體能接受的鈦金屬牙根植入骨頭，作為支撐假牙的根基"
        }
      ]
    })
  }
  const url = apiUrl('menu/service_item')
  return axios.get(url, {params})
}

export function getMenuEquipmentAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": "19",
          "img_url": "https://i.imgur.com/4iVswq9.jpg",
          "category": "預設項目",
          "title": "器械消毒鍋  ",
          "intro": "高溫高壓蒸氣滅菌鍋，確保器械安全性"
        },
        {
          "id": "20",
          "img_url": "https://i.imgur.com/4iVswq9.jpg",
          "category": "預設項目",
          "title": "超音波洗淨機",
          "intro": "去除器械上細微死角的髒污"
        }
      ]
    })
  }
  const url = apiUrl('menu/equipment')
  return axios.get(url, {params})
}

export function getMenuEquipmentSpaceAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": "1",
          "img_url": "https://i.imgur.com/RaNABbj.jpg",
          "category": "預設項目",
          "title": "消毒室（消毒供應空間）",
          "intro": "高規格消毒器械，感控流程做到最好"
        },
        {
          "id": "2",
          "img_url": "https://i.imgur.com/RaNABbj.jpg",
          "category": "預設項目",
          "title": "Ｘ光室（醫事放射空間）",
          "intro": "安全X光照射，完整了解口腔狀況"
        }
      ]
    })
  }
  const url = apiUrl('menu/equipment_space')
  return axios.get(url, {params})
}

export function getClinicEquipmentAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": "19",
          "title": "器械消毒鍋",
          "intro": "高溫高壓蒸氣滅菌鍋，確保器械安全性"
        },
        {
          "id": "20",
          "title": "超音波洗淨機",
          "intro": "去除器械上細微死角的髒污"
        }
      ]
    })
  }
  const url = apiUrl('clinic/equipment')
  return axios.get(url, {params})
}

export function getClinicEquipmentSpaceAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": "1",
          "title": "消毒室（消毒供應空間）",
          "intro": "高規格消毒器械，感控流程做到最好"
        },
        {
          "id": "2",
          "title": "Ｘ光室（醫事放射空間）",
          "intro": "安全X光照射，完整了解口腔狀況"
        }
      ]
    })
  }
  const url = apiUrl('clinic/equipment_space')
  return axios.get(url, {params})
}

export function getDentcoIconsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": 1,
          "path": "dental_icon_other.png",
          "description": "其他",
          "full_path": "https://cdn.dentco.tw/asset/dentco_icon/dental_icon_other.png"
        }
      ]
    })
  }
  const url = apiUrl('dental-icon')
  return axios.get(url, {params})
}

export function getClinicServiceItemAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": "1",
          "title": "植牙療程",
          "intro": "植牙是把身體能接受的鈦金屬牙根植入骨頭，作為支撐假牙的根基"
        },
        {
          "id": "2",
          "title": "植牙療程",
          "intro": "植牙是把身體能接受的鈦金屬牙根植入骨頭，作為支撐假牙的根基"
        }
      ]
    })
  }
  const url = apiUrl('clinic/service_item')
  return axios.get(url, {params})
}

export function saveClinicServiceItemAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'setting_service_item')
  return axios.post(url, data)
}

export function saveClinicEquipmentSpaceAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'setting_equipment_space')
  return axios.post(url, data)
}

export function saveClinicEquipmentAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'setting_equipment')
  return axios.post(url, data)
}

export function getClinicBaseInfoAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {}
    })
  }
  const url = apiUrl('clinic', 'info')
  return axios.get(url, {params})
}

export function updateClinicColorAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'color')
  return axios.post(url, data)
}

export function getClinicQuestionActiveAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "question_active": 1
      }
    })
  }
  const url = apiUrl('clinic', 'question_active')
  return axios.get(url, {params})
}

export function updateClinicQuestionActiveAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('clinic', 'question_active')
  return axios.put(url, data)
}

// ===== 診所衛教影音相關 API =====
export function getClinicVideosAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "short": [
          {
            "id": "1",
            "clinic_code": "0000000088",
            "platform": "youtube-shorts",
            "type": "short",
            "url": "https://www.youtube.com/shorts/Z7sv6WD_prM",
            "sort": "1",
            "created_at": "2025-10-21 02:33:10",
            "updated_at": "2025-10-21 02:33:10"
          },
          {
            "id": "2",
            "clinic_code": "0000000088",
            "platform": "youtube-shorts",
            "type": "short",
            "url": "https://www.youtube.com/shorts/WesUCGe3-ps",
            "sort": "2",
            "created_at": "2025-10-21 02:33:10",
            "updated_at": "2025-10-21 02:33:10"
          }
        ],
        "regular": [
          {
            "id": "5",
            "clinic_code": "0000000088",
            "platform": "youtube",
            "type": "regular",
            "url": "https://www.youtube.com/watch?v=CEbF0cWr5es",
            "sort": "1",
            "created_at": "2025-10-21 02:33:10",
            "updated_at": "2025-10-21 02:33:10"
          }
        ]
      }
    })
  }
  const url = apiUrl('clinic', 'videos')
  return axios.get(url, {params})
}

export function saveClinicVideosAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "success": true,
        "message": "影音資料已同步",
        "results": {
          "created": [16],
          "updated": [8, 15, 10],
          "deleted": []
        }
      }
    })
  }
  const url = apiUrl('clinic', 'videos')
  return axios.post(url, data)
}

export function saveClinicShortVideosAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "success": true,
        "message": "影音資料已同步",
        "results": {
          "created": [16],
          "updated": [8, 15, 10],
          "deleted": []
        }
      }
    })
  }
  const url = apiUrl('clinic', 'videos', 'short')
  return axios.post(url, data)
}

export function saveClinicRegularVideosAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "success": true,
        "message": "影音資料已同步",
        "results": {
          "created": [16],
          "updated": [8, 15, 10],
          "deleted": []
        }
      }
    })
  }
  const url = apiUrl('clinic', 'videos', 'regular')
  return axios.post(url, data)
}

// ===== 診所休診自動回覆設定 API =====
export function getOffworkAutoreplyAPI(params) {
  const url = apiUrl('clinic', 'offwork-autoreply')
  return axios.get(url, { params })
}

export function createOffworkAutoreplyRuleAPI(data, params) {
  const url = apiUrl('clinic', 'offwork-autoreply', 'rules')
  return axios.post(url, data, { params })
}

export function updateOffworkAutoreplyRuleAPI(id, data, params) {
  const url = apiUrl('clinic', 'offwork-autoreply', 'rules', id)
  return axios.put(url, data, { params })
}

export function deleteOffworkAutoreplyRuleAPI(id, params) {
  const url = apiUrl('clinic', 'offwork-autoreply', 'rules', id)
  return axios.delete(url, { params })
}


export function getClinicFaqsAPI(params) {
  const url = apiUrl('clinic_faqs')
  return axios.get(url, { params })
}

export function saveClinicFaqsAPI(data) {
  const url = apiUrl('clinic_faqs')
  return axios.post(url, data)
}
